package com.essntl.uikit.components.button.tinted

import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.ui.unit.Dp
import com.essntl.uikit.components.button.EsButton
import com.essntl.uikit.components.button.EsButtonSize
import com.essntl.uikit.components.icons.EsSmallIcon
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme

@Composable
fun EsSmallTintedButton(
    onClick: () -> Unit,
    text: String,
    prefixIconRes: String? = null,
    suffixIconRes: String? = null,
    enabled: Boolean = true,
    loading: Boolean = false,
    contentPadding: PaddingValues? = null,
    height: Dp? = null,
    interactionSource: MutableInteractionSource = remember { MutableInteractionSource() },
    modifier: Modifier = Modifier,
) {
    val essntlColorScheme = MaterialTheme.esColorScheme
    val buttonPadding = contentPadding ?: PaddingValues(horizontal = 1.5f.spacing)

    EsButton(
        onClick = onClick,
        size = EsButtonSize.Small,
        colors = getTintedButtonColors(essntlColorScheme),
        text = text,
        border = null,
        prefix = prefixIconRes?.let { { EsSmallIcon(res = it) } },
        suffix = suffixIconRes?.let { { EsSmallIcon(res = it) } },
        enabled = enabled,
        loading = loading,
        withFocusBorder = true,
        shape = RoundedCornerShape(EsConstants.ButtonBorderRadius),
        contentPadding = buttonPadding,
        height = height,
        interactionSource = interactionSource,
        modifier = modifier,
    )
}